export default function Template(props) {
  const documentTitle = props.documentTitle ? " - " + props.documentTitle : "";
  document.title = "Qrpedir ".concat(documentTitle);

  return props.children;
}
